import { ColorEnum } from '@/constants/color'
import { ButtonStateEnum } from '@/features/ui/buttons/constants'
import {
    Easing,
    interpolateColor,
    useAnimatedReaction,
    useAnimatedStyle,
    useSharedValue,
    withTiming,
} from 'react-native-reanimated'

export const useAnimatedBackgroundColorStyle = (state: ButtonStateEnum) => {
    const progress = useSharedValue(0)

    useAnimatedReaction(
        () => state,
        () => {
            progress.value = withTiming(state === ButtonStateEnum.Pressed ? 1 : 0, {
                duration: 150,
                easing: Easing.out(Easing.linear),
            })
        }
    )

    return useAnimatedStyle(() => {
        const backgroundColor = interpolateColor(
            progress.value,
            [0, 1],
            [ColorEnum.Violet150, ColorEnum.VIOLET_200]
        )

        return { backgroundColor }
    })
}
